import React from 'react';
import Icon from '@mui/material/Icon';

interface IProps {
    url: string;
}

const Component: React.FC<IProps> = ({ url }: IProps) => {
    return (
        <Icon className="lang__ico-wrap_list">
            <img className="lang__ico" src={url} />
        </Icon>
    );
};

const LangIcoComponent = React.memo(Component);

export default LangIcoComponent;
